module.exports = __webpack_public_path__ + "img/generic.0a0d3779.png";